export default __webpack_public_path__ + "static/media/UI_BGFormation.3725cf6d.png";